const UserType = {
  OWNER: 'OWNER',
  END_USER: 'END_USER',
}

export { UserType }
